module.exports = __webpack_public_path__ + "static/OSRS-comp-screenshot-6c7ba136dd6e8b876468bc8069b4672a.png";